// One label per session type for the whole tracks tab — the chip on a track tile, the filter pills
// above the grid, and the session column inside the track modal all read from here. They used to
// carry three separate copies in two registers ("квала" / "Кваліфікація" / "кваліфікація").
export const SESSION_LABELS = { RACE: "Гонка", SPRINT: "Спринт", QUALIFICATION: "Кваліфікація" };
